export default function pageTitle (title) {
  return `${title} | Магазин воздушных шаров Шарарам.рф`;
}